<!-- Page Wrapper -->
<div id="wrapper">
  <app-sidebar></app-sidebar>

  <!-- End of Sidebar -->

  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column">

    <!-- Main Content -->
    <div id="content">

      <!-- Topbar -->
      <app-header></app-header>
      <!-- End of Topbar -->

      <!-- Begin Page Content -->
      <div class="container-fluid">


        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 class="h3 mb-0 text-gray-800">Settings</h1>
          
        </div>
      


<div class="card">
  <div class="card-header">
    
   
    
    <!-- START TABS DIV -->
    <div class="tabbable-responsive">
      <div class="tabbable">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="first-tab" data-toggle="tab" href="#first" role="tab" aria-controls="first" aria-selected="true">Update User Details</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="second-tab" data-toggle="tab" href="#second" role="tab" aria-controls="second" aria-selected="false">Change Password</a>
          </li>
          
    </ul>
      </div>
    </div>
  </div>
  <div class="card-body">
    
    <div class="tab-content">
      <div class="tab-pane fade show active" id="first" role="tabpanel" aria-labelledby="first-tab">
        <div class="p-5">
            <div class="text-center">
              <h1 class="h4 text-gray-900 mb-4">User Details</h1>
            </div>
      <div class="container"> 
            <form class="user">
              <div class="form-group row">
                <div class="col-sm-6 mb-3 mb-sm-0">
                  <input type="text" class="form-control form-control-user" id="exampleFirstName" placeholder="First Name">
                </div>
                <div class="col-sm-6">
                  <input type="text" class="form-control form-control-user" id="exampleLastName" placeholder="Last Name">
                </div>
              </div>
              
              <div class="form-group row">
                <div class="col-sm-6 mb-3 mb-sm-0">
                 <input type="email" class="form-control form-control-user" id="exampleInputEmail" placeholder="Email Address">
                </div>
                <div class="col-sm-6">
                 
                  <input type="text" class="form-control form-control-user" id="examplePhone" placeholder="Phone">
                
                </div>
              </div>
      <div class="text-center">
              <a href="javascript:void(0);" class="btn btn-primary btn-user">
                Submit
              </a>
              </div>
            </form>
      </div>
            <hr>
            
          </div>
      </div>
      <div class="tab-pane fade" id="second" role="tabpanel" aria-labelledby="second-tab">
        <div class="p-5">
                <div class="text-center">
                  <h1 class="h4 text-gray-900 mb-4">Forgot Your Password?</h1>
                  
                </div>
         <div class="container"> 
                <form class="user">
                   <div class="form-group row">
                      <div class="col-sm-4 mb-3 mb-sm-0">
                    <input type="password" class="form-control form-control-user" id="exampleInputPassword" placeholder="Old Password">
                  </div>
        <div class="col-sm-4 mb-3 mb-sm-0">
                    <input type="password" class="form-control form-control-user" id="exampleInputNewPassword" placeholder="New Password">
                  </div>
        <div class="col-sm-4 mb-3 mb-sm-0">
                    <input type="password" class="form-control form-control-user" id="exampleInputNewPassword" placeholder="Confirm Password">
                  </div>
        </div>
        <div class="text-center">
                  <a href="javascript:void(0);" type="submit" class="btn btn-primary btn-user btn-user">
                    update Password
                  </a>
        </div>
                </form>
                
        </div>
              </div>
      </div>
    
  
  </div>
    <!-- END TABS DIV -->
    
  </div>
  




  
  </div>
  </div>
      <!-- /.container-fluid -->




    </div>
    <!-- End of Main Content -->

    <!-- Footer -->
    <app-footer></app-footer>
    <!-- End of Footer -->

  </div>
  <!-- End of Content Wrapper -->

</div>
<!-- End of Page Wrapper -->

<!-- Scroll to Top Button-->
<a class="scroll-to-top rounded" href="#page-top">
  <i class="fas fa-angle-up"></i>
</a>
